const grayBackgound = '#f9f9f9'
const lightgray = '#e0e0e0'
const mediumgray = '#a5a5a5'
const weight = {
	light: 300,
	medium: 500,
	bold: 700,
}

const style = theme => ({
	page: {
		marginBottom: 56,
		marginTop: 56,
		[theme.breakpoints.up('sm')]: {
			marginTop: 64,
			marginBottom: 64,
		},
		padding: 10,
		fontFamily: '"Poppins", sans-serif',
		fontWeight: weight.light,
	},
	pageTitle: {
		textAlign: 'center',
		fontWeight: weight.medium,
		color: theme.palette.primary.main,
	},
	pageSubTitle: {
		textAlign: 'center',
		fontWeight: weight.medium,
	},
	error: {
		color: theme.palette.error.main,
	},
	// Loading
	loading: {
		zIndex: theme.zIndex.drawer + 1,
	},
	// Feedback
	feedback: {
		zIndex: theme.zIndex.drawer + 1,
	},
	// Top bar
	topBar: {
		'& .logoContainer': {
			flexGrow: 1,
			textAlign: 'center',
			'& .logo': {
				height: 30,
			}
		},
	},
	// Menù categorie
	categoriesDrawer: {
		backgroundColor: theme.palette.primary.main,
		width: '100%',
		maxWidth: 960,
		'& .close': {
			float: 'right',
			'& *': {
				color: theme.palette.getContrastText(theme.palette.primary.main),
			}
		},
		'& .search': {
			// float: 'left',
			// width: 'calc(100% - 50px)',
			'& input': {
				margin: 10,
				width: 'calc(100% - 88px)',
				borderRadius: 14,
				border: 0,
				padding: '2px 8px',
				fontFamily: '"Poppins", sans-serif',
				fontSize: 14,
				fontWeight: weight.light,
				'&:focus': {
					outlineWidth: 0,
				}
			},
			'& .searchButton': {
				position: 'absolute',
				right: 55,
				top: 7,
			}
		},
		'& .categories': {
			'& .category': {
				'& *': {
					color: theme.palette.getContrastText(theme.palette.primary.main),
				}
			},
		}
	},

	// Lista prodotti
	productsList: {
		marginBottom: 15,
		'& del': {
			opacity: 0.5,
			marginRight: 8,
		},
		'& .product': {
			'&.grid': {
				// Prodotto in visualizzazione griglia
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: '#fff',
				border: `1px solid ${lightgray}`,
				[theme.breakpoints.down('xs')]: {
					borderTop: 0,
					borderRight: 0,
					borderLeft: 0,
				},
				padding: theme.spacing(2),
				textAlign: 'center',
				'& .price': {
					fontSize: 30,
					padding: '10px 0',
					fontWeight: weight.medium,
					'& del': {
						fontSize: '60%',
						fontWeight: weight.light,
					},
				},
				'& .description': {
					fontSize: '80%',
					height: 18,
				},

				'& .titleContainer': {
					width: 250,
					height: 200,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				},

				'& .titleCategory': {
					textAlign: 'center',
					color: window.__colorMain,
					fontSize: 26,
					lineHeight: '110%',
				},
			},
			'&.list': {
				// Prodotto in visualizzazione lista
			},
			// Parti in comune sia per la lista che per la griglia
			'& .pic': {
				[theme.breakpoints.up('xs')]: {
					height: '60vw',
				},
				[theme.breakpoints.up('sm')]: {
					height: '30vw',
				},
				[theme.breakpoints.up('md')]: {
					height: '20vw',
				},
				[theme.breakpoints.up('xl')]: {
					height: '15vw',
				},
				margin: '0 auto 10px',
				width: '98%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				overflow: 'hidden',
				'& img': {
					width: '100%',
					height: '100%',
					objectFit: 'scale-down',
				},
			},
			'& .title': {
				color: window.__colorMain,
			},
			'& .price': {
				fontWeight: weight.medium,
				'& del': {
					fontSize: '80%',
					fontWeight: weight.light,
				},
			},
			'& .availability': {
				fontSize: 12,
				fontWeight: weight.medium,
				color: theme.palette.primary.main,
			}
		},
	},

	// Dettaglio prodotto
	productDetails: {
		'& .gallery': {
			[theme.breakpoints.up('sm')]: {
				borderRight: `1px solid ${lightgray}`,
			},
			'& .image-gallery-slide': {
				height: '60vw',
				[theme.breakpoints.up('sm')]: {
					maxHeight: 400,
				},
				[theme.breakpoints.up('md')]: {
					maxHeight: 500,
				},
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				'& img.image-gallery-image': {
					width: '100%',
					height: '100%',
					objectFit: 'scale-down',
				}
			}
		},
		'& .options': {
			marginTop: 15,
			borderTop: `1px solid ${lightgray}`,
			paddingTop: 12,
			paddingBottom: 12,
			'& .label': {
				fontWeight: weight.medium,
				color: theme.palette.primary.main,
				display: 'inline-block',
				paddingTop: 10,
			},
		},
		'& .itemPrice': {
			marginTop: 15,
			borderTop: `1px solid ${lightgray}`,
			paddingTop: 12,
			paddingLeft: 15,
			fontSize: 26,
			fontWeight: weight.medium,
			color: theme.palette.primary.main,
			'& del': {
				opacity: 0.5,
				marginRight: 8,
				fontSize: '60%',
				fontWeight: weight.light,
			},
		},
		'& .finalPrice': {
			marginTop: 15,
			borderTop: `1px solid ${lightgray}`,
			paddingTop: 12,
			// paddingLeft: 15,
			fontSize: 16,
			fontWeight: weight.medium,
			// color: theme.palette.secondary.main,
		},
		'& .availability': {
			color: theme.palette.primary.main,
			fontSize: 12,
		},
		'& .quantity': {
			marginTop: 15,
			// borderTop: `1px solid ${lightgray}`,
			// paddingTop: 12,
			paddingBottom: 12,
			'& .label': {
				display: 'inline-block',
				padding: 10,
			},
			'& .addButton': {
				marginTop: 4,
			},
		},
	},

	// Carrello
	cartDrawer: {
		backgroundColor: theme.palette.secondary.main,
		width: '100%',
		maxWidth: 960,
		'& .productsList': {
			margin: 10,
			fontWeight: weight.medium,
			'& h3': {
				marginTop: 12,
				color: theme.palette.primary.main,
				textAlign: 'right',
				textTransform: 'uppercase',
				fontWeight: weight.light,
			},
			'& .product': {
				marginTop: 8,
				marginBottom: 8,
				fontSize: 14,
				'& .name': {
					fontSize: 16,
					// marginBottom: 5,
				},
				'& .options': {
					'& .option': {
						marginBottom: 5,
					}
				},
				'& .price': {
					fontSize: 16,
					fontWeight: weight.medium,
					marginBottom: 10,
					color: theme.palette.primary.main,
				},
				'& .availability': {
					fontSize: 12,
					fontWeight: weight.medium,
					marginBottom: 4,
				},
				'& .pic': {
					width: '100%',
					display: 'flex',
					overflow: 'hidden',
					alignItems: 'center',
					'& img': {
						width: '100%',
					}
				},
				'& .delete': {
					marginTop: -32,
				},
			}
		},
		'& .footer': {
			textAlign: 'center',
		},
	},

	// Ordine
	order: {
		'& .box': {
			backgroundColor: grayBackgound,
			border: `1px solid ${lightgray}`,
			borderRadius: 6,
			padding: '5px 15px',
			margin: '16px 0',
		},
		'& h4': {
			marginTop: 12,
			color: theme.palette.primary.main,
			textAlign: 'center',
			fontWeight: weight.medium,
			'& .icon': {
				verticalAlign: 'bottom',
			}
		},
		'& .summary': {
			'& .product': {
				lineHeight: '1.2em',
				'& .name': {
					fontWeight: weight.medium,
				},
			},
			'& .amount': {
				float: 'right',
			},
			'& .totalAmount': {
				fontWeight: weight.medium,
			},
		},
		'& .inputForm': {
			marginBottom: 10,
		},
		'& .privacy': {
			'& p': {
				lineHeight: '100%',
			},
			'& a': {
				color: theme.palette.primary.main,
				textDecoration: 'underline',
			},
		},
		'& .submit': {
			textAlign: 'center',
		},
	},

	// * Components *
	quantitySelector: {
		display: 'inline-block',
		width: 150,
		position: 'relative',
		height: 42,
		backgroundColor: 'white',
		boxSizing: 'border-box',
		'& *': {
			boxSizing: 'inherit',
		},
		'& .quantity-button': {
			position: 'absolute',
			padding: '5px 0px',
			cursor: 'pointer',
			width: '25%',
			textAlign: 'center',
			color: '#333',
			fontSize: 18,
			lineHeight: 1.7,
			border: '1px solid #d8d8d8',
			height: 42,
			transform: 'translateX(-100%)',
			userSelect: 'none',
			'&:focus': {
				outlineWidth: 0,
			}
		},
		'& .quantity-down': {
			position: 'absolute',
			top: 0,
			left: '25%',
		},
		'& .quantity-up': {
			position: 'absolute',
			top: 0,
			right: '-25%',
		},
		'& input': {
			fontSize: '1rem',
			border: 'none',
			borderTop: '1px solid #d8d8d8',
			borderBottom: '1px solid #d8d8d8',
			height: 42,
			lineHeight: 1.65,
			display: 'block',
			margin: 0,
			left: '25%',
			width: '50%',
			padding: '0px 10px',
			textAlign: 'center',
			position: 'absolute',
			boxSizing: 'border-box',
			'&:focus': {
				outlineWidth: 0,
			}
		},
	},
	// * Pages *
	textPage: {
		'& h2': {
			textAlign: 'center',
			fontWeight: weight.medium,
			color: theme.palette.primary.main,
		},
		'& h3': {
			textAlign: 'center',
			fontWeight: weight.medium,
			color: theme.palette.primary.dark,
		},
	},
	homeBackground: {
		zIndex: -1,
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100vh',
		backgroundImage: 'url("/splash.jpg")',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundAttachment: 'fixed',
	},
	homePage: {
		marginTop: 56,
		[theme.breakpoints.up('sm')]: {
			marginTop: 64,
			marginBottom: 64,
		},

		paddingBottom: 20,

		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		//justifyContent: 'center',

		// Welcome title and shop description
		'& .box': {
			width: '100%',
			textAlign: 'center',
			justifyContent: 'center',
			//backgroundColor: 'rgba(255, 255, 255, 0.9)',
			backgroundColor: grayBackgound,
			//position: 'fixed',
			marginTop: 36,
			borderRadius: 0,
		},
	},
	shopInfoPage: {
		'& label': {
			fontWeight: weight.medium,
		},
		'& .mapContainer': {
			margin: -10,
			marginBottom: 20,
			width: 'calc(100% + 20px)',
			height: '80vw',
			maxHeight: 500,
		},
		'& .mapIcon': {
			color: theme.palette.primary.main,
			fontSize: '200%',
		},
		'& .socialIcons': {
			textAlign: 'center',
			color: theme.palette.primary.main,
			fontSize: '200%',
			'& a': {
				color: theme.palette.primary.main,
				marginRight: 20,
			}
		},
		'& .phone': {
			textAlign: 'center',
		}
	},
	// Calendar
	calendar: {
		boxSizing: 'border-box',
		fontSize: '1rem',
		cursor: 'pointer',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		background: theme.palette.primary.main,
		minHeight: '2rem',
		lineHeight: '2rem',
		color: '#f0f0f0',
		fontWeight: 700,
	},
	calendarBody: {
		border: '2px solid ' + theme.palette.primary.main
	},
	calendarDayNames: {
		display: 'flex',
		flexWrap: 'wrap',
		maxWidth: 1000,
		margin: '0 auto',
		paddingLeft: 10,
		paddingRight: 28,
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	calendarDay: {
		width: 'calc(100% / 7)',
		height: '2.75rem',
		display: 'inline-block',
		backgroundColor: 'white',
		padding: 0,
		margin: '0 0 4px 0',
		boxSizing: 'border-box',
		zIndex: 1,
		textAlign: 'center',
	},
	calendarOnlyDay: {
		width: '3.75rem',
		height: '2.75rem',
		position: 'relative',
		color: '#3a3a3a',
		zIndex: 100,
		lineHeight: '2.75rem',
	},
	availabilityBar: {
		height: 4,
		width: '2.25rem',
		margin: '0 auto',
		marginTop: -8,
		backgroundColor: '#1ab394',
		borderRadius: 5,
	},
	unavailabilityBar: {
		height: 4,
		width: '2.25rem',
		margin: '0 auto',
		marginTop: -8,
		backgroundColor: '#ec4758',
		borderRadius: 5,
	},
	calendarPrevious: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: '2rem'
	},
	calendarNext: {
		display: 'flex',
		alignItems: 'center',
		marginRight: '2rem'
	},
	calendarBefore: {
		color: `${mediumgray}`,
	},
	calendarSelected: {
		background: '#1c84c6',
		color: '#f0f0f0',
		fontWeight: 'bold',
		borderRadius: 5,
	},
	calendarToday: {
		background: `${mediumgray}`,
	},
	//AvailableHours
	// TODO
})

export default style
